import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox,
	FormControlLabel
} from "@mui/material";
import moment from "moment";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import SearchIcon from "@mui/icons-material/Search";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import { useSelector, useDispatch } from "react-redux";
import { FormControl } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useHistory, useNavigate } from "react-router-dom";
import SOLogout from "../../components/Logout/SOLogout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns"
import "jspdf-autotable";
import Excel from "../../assets/img/excel.png";
import PDF from "../../assets/img/pdf1.png";
import Layout from "../../components/Wrappers/Layout";
import { dealerGetFeeReportList } from "../../redux/actions/dealerGetFeeReportListAction";
import { getTransactionTypeListDetails } from "../../redux/actions/getTransactionTypeListAction";
import Util from "../../validation/index";
import { dealerFeeExcelPdfFile } from '../../redux/actions/dealerFeeExcelPdfFileAction'
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const DealerFeeReport = () => {
	const csv = "1";
	const pdf = "0";
	const [isLoading, setIsLoading] = useState(true);
	const navigate = useHistory();

	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);

	const [getFeeReportListStatus, setGetFeeReportListStatus] = useState(false);
	const [getFeeReportListArray, setGetFeeReportListArray] = useState([]);

	const [getTransactionTypeListResArray, setGetTransactionTypeListResArray] =
		useState([]);
	const [getTransactionTypeListStatus, setGetTransactionTypeListStatus] =
		useState(false);

	const [getFeeReportFileResStatus, setGetFeeReportFileRes] =
		useState(false)

	const [getTranactionId, setTransactionId] = useState("");

	const [transactionType, setTransactionType] = useState("");
	const [transactionSubType, setTransactionSubType] = useState("");

	const [getFromCustomerId, setGetFromCustomerId] = useState("");
	const [editCurrency, setEditCurrency] = useState("");
	var date = new Date();
	const [selectedDate, setSelectedDate] = useState(
		new Date(date.getFullYear(), date.getMonth(), 1)
	);
	const [selectedToDate, setSelectedToDate] = useState(new Date());
	const handleDateChange = (date) => {
		setSelectedDate(date);
	};
	const handleToDateChange = (date) => {
		setSelectedToDate(date);
	};

	const getDealerFeeReportList = useSelector(
		({ dealerGetFeeReportLists }) => dealerGetFeeReportLists
	);
	const getTransactionTypeListRes = useSelector(
		({ getTransactionTypeList }) => getTransactionTypeList
	);

	const getFeeExcelPdfFileRes = useSelector(
		({ dealerFeeExcelPdfFiles }) => dealerFeeExcelPdfFiles
	);

	const dispatch = useDispatch();
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};
	var authToken = regenerateTokenRes.data.AuthToken;
	const classes = useStyles();

	const handleChange = ({ target: { name, value } }) => {
		if (name === "transactionType") {
			setTransactionType(value == "Select Transaction Type" ? "" : value);
			// setTransactionType(value);
		}
		if (name === "transactionSubType") {
			setTransactionSubType(value == "Select Transaction Type" ? "" : value);
			// setTransactionType(value);
		}
		if (name === "fromCustomerId") {
			Util.verifyNumber(value)
				? setGetFromCustomerId(value)
				: setGetFromCustomerId(getFromCustomerId);
		}

		if (name === "Currency") {
			setEditCurrency(value == "Select Currency" ? "" : value);
		}
	};
	const getTransactionTypeListReqApi = () => {
		setGetTransactionTypeListStatus(true);
		const getTransactionTypeListReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			}
		};

		return dispatch(
			getTransactionTypeListDetails(getTransactionTypeListReq, authToken)
		);
	};

	const GetTransactionTypeListFunc = () => {
		if (getTransactionTypeListStatus) {
			if (getTransactionTypeListRes.data.status == "success") {
				setGetTransactionTypeListResArray(
					getTransactionTypeListRes.data.transactionType
				);
			}
			if (getTransactionTypeListRes.data.status == "failed") {
				setGetTransactionTypeListResArray(getTransactionTypeListRes.data);
				if (
					getTransactionTypeListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getTransactionTypeListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		GetTransactionTypeListFunc();
	}, [getTransactionTypeListRes.data.status]);

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getTransactionTypeListReqApi();
		}
	}, [regenerateTokenRes.data.status]);

	const getDealerFeeReportListReq = () => {
		setIsLoading(true);
		setGetFeeReportListStatus(true);
		let req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId || "",
				// walletOwnerId: regenerateTokenRes.data.partnerId || "",
				fdtstamp: moment(selectedDate).format("DD/MM/YYYY"),
				tdtstamp: moment(selectedToDate).format("DD/MM/YYYY"),
				customerId: getFromCustomerId,
				transactionId: getTranactionId,
				transactionType: transactionType,
				currency: editCurrency
				// isFee: isFee,
				// transactionType == "All" ? "" : transactionType,

				// transactionAmount: getTransactionAmount,
				// dsrContact: getDsrContact,
				// customerContact: getCustomerContact,
				// currency: editCurrency == "All" ? "" : editCurrency,
			}
		};
		dispatch(dealerGetFeeReportList(req, authToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getDealerFeeReportListReq();
		}
	}, [regenerateTokenRes.data.status]);

	const getDealerFeeReportListResFunc = () => {
		if (getFeeReportListStatus) {
			if (getDealerFeeReportList.data.status == "success") {
				setIsLoading(false);
				setGetFeeReportListArray(
					[].concat(getDealerFeeReportList.data.transactionList)
				);
			}
			if (getDealerFeeReportList.data.status == "failed") {
				setIsLoading(false);
				setGetFeeReportListArray(getDealerFeeReportList.data);
				if (
					getDealerFeeReportList.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getDealerFeeReportList.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}

			if (getDealerFeeReportList.data.status == "Not Found") {
				setIsLoading(false);
				setGetFeeReportListArray(getDealerFeeReportList.data);
			}
		}
	};
	useEffect(() => {
		getDealerFeeReportListResFunc();
	}, [getDealerFeeReportList.data.status]);


	const getFeeReportFileExcelOrPdf = (csvOrPdf) => {
		setGetFeeReportFileRes(true);
		let req = {

			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId || "",
				action: "csv",
				customerId: getFromCustomerId,
				fdtStamp: moment(selectedDate).format("DD/MM/YYYY"),
				tdtStamp: moment(selectedToDate).format("DD/MM/YYYY"),
				currency: "BDT",
				transactionType: transactionType,
				transactionSubType: transactionSubType,
				reportFileType: csvOrPdf == "1" ? "csv" : "pdf",
				// transactionId: getTranactionId,
				// isFee: isFee,

			}
		};

		return dispatch(dealerFeeExcelPdfFile(req, authToken));
	};

	useEffect(() => {
		if (getFeeReportFileResStatus) {
			if (getFeeExcelPdfFileRes.data.status == "success") {
				var link = document.createElement("a");
				link.download = getFeeExcelPdfFileRes.data.fileName;
				link.href =
					"data:application/octet-stream;base64," +
					getFeeExcelPdfFileRes.data.fileDate.split(`,`)[1];
				link.click();
			}
		}
	}, [getFeeExcelPdfFileRes.data.status]);


	useEffect(() => {
		if (getFeeExcelPdfFileRes.data.status == "success") {
			setPage(0);
		}
	}, [getFeeExcelPdfFileRes.data.status]);
	return (
		<>
			<Layout>
				<Card>
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<FormControl fullWidth>
								 <LocalizationProvider dateAdapter={AdapterDateFns}>
									<DatePicker
										label="From Date"
										format="MM/dd/yyyy"
										value={selectedDate}
										onChange={handleDateChange}
										disableFuture={true}
									/>
								  </LocalizationProvider>
							</FormControl>
						</Grid>

						<Grid item xs={12} sm={12} md={3} lg={3}>
							<FormControl fullWidth>
								 <LocalizationProvider dateAdapter={AdapterDateFns}>
									<DatePicker
										label="To Date"
										format="MM/dd/yyyy"
										value={selectedToDate}
										onChange={handleToDateChange}
										disableFuture={true}
									/>
								  </LocalizationProvider>
							</FormControl>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								// required
								size="small"
								color="primary"
								type="text"
								label="From Customer ID"
								fullWidth={true}
								name="fromCustomerId"
								value={getFromCustomerId}
								onChange={handleChange}
								// onChange={onInputChange}
								// onChange={(e) => onInputChange(e, "number")}
								style={{ marginTop: "3px" }}
							></TextField>
						</Grid>

						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								style={{ marginTop: "3px" }}
								select
								autoFocus
								margin="dense"
								id="name"
								label="Transaction Type"
								type="name"
								fullWidth
								name="transactionType"
								value={transactionType || ""}
								onChange={handleChange}
							// onChange={(e) => onInputChange(e)}
							>
								<MenuItem
									value="Select Transaction Type"
									selected="Select Transaction Type"
								>
									Select Transaction Type
								</MenuItem>
								{getTransactionTypeListRes.success &&
									getTransactionTypeListRes.data.transactionType.map((x) => (
										<MenuItem value={x}>{x}</MenuItem>
									))}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								// required
								style={{ marginTop: "3px" }}
								select
								autoFocus
								margin="dense"
								label="Transaction SubType"
								fullWidth
								name="transactionSubType"
								value={transactionSubType || "All"}
								// defaultValue={"Select Currency" || editCurrency}

								onChange={handleChange}
							// onChange={(e) => onInputChange(e)}
							>
								<MenuItem value="All" selected="All">
									All
								</MenuItem>
								<MenuItem value="Bank Transfer">Bank Transfer</MenuItem>
								<MenuItem value="Card Transfer">Card Transfer</MenuItem>
								<MenuItem value="Purchase Transfer">Purchase Transfer</MenuItem>
								<MenuItem value="Redeem">Redeem</MenuItem>
								<MenuItem value="Transfer">Transfer</MenuItem>
								<MenuItem value="Wallet Transfer">Wallet Transfer</MenuItem>
							</TextField>
						</Grid>

						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								required
								style={{ marginTop: "3px" }}
								select
								autoFocus
								margin="dense"
								label="Currency"
								fullWidth
								name="Currency"
								// value={"Select Currency" || editCurrency}
								defaultValue={"Select Currency" || editCurrency}

							// onChange={handleChange}
							// onChange={(e) => onInputChange(e)}
							>
								<MenuItem value="Select Currency" selected="Select Currency">
									Select Currency
								</MenuItem>
								<MenuItem value="BDT">BDT</MenuItem>
							</TextField>
						</Grid>

						<Grid item xs={12} sm={6} md={3} lg={3}>
							<CustomButton
								style={{
									padding: "8px",
									margin: "15px 8px"
								}}
								endIcon={<AiOutlineSearch />}
								variant="contained"
								onClick={getDealerFeeReportListReq}
							>
								Search
								<SearchIcon style={{ marginLeft: "4px", fontSize: "21px" }} />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>
				{isLoading ? (
					<LoadingSpinner />
				) : getFeeReportListArray.length == undefined ||
					!getFeeReportListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}>
									Report Table
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 themeBackground"
									variant="secondary"
									style={{ color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<div>
						<Card>
							<Grid
								container
								style={{
									padding: "10px"
								}}
							>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Typography variant="body1" style={{ fontWeight: "700" }}>
										Report Table
									</Typography>
								</Grid>
								<Grid
									container
									style={{
										padding: "10px",
										textAlign: "center",
										justifyContent: "right"
									}}
								>
									<Grid
										container
										style={{
											padding: "10px",
											textAlign: "center",
											justifyContent: "right",
											gap: "10px"
										}}
									>
										<Grid item xs={4} sm={4} md={1} lg={1}>

											<img
												src={Excel}
												style={{ height: "30px", cursor: "pointer" }}
												onClick={() => {
													getFeeReportFileExcelOrPdf(csv)
												}}
											></img>
										</Grid>
										<Grid item xs={4} sm={4} md={1} lg={1}>

											<img
												src={PDF}
												style={{ height: "30px", cursor: "pointer" }}
												onClick={() => {
													getFeeReportFileExcelOrPdf(pdf)
												}}
											></img>
										</Grid>
									</Grid>
								</Grid>
								<TableContainer component={Paper} className="text-nowrap my-3">
									<Table className={classes.table}>
										<TableHead>
											<TableRow
												style={{ background: "#00b9f5" }}
												className="themeBackground"
											>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Role{" "}
												</TableCell>

												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Transaction type
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Transaction SubType
												</TableCell>

												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													currency{" "}
												</TableCell>

												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													No.of transaction
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Total fee received
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Total Fee paid
												</TableCell>
											</TableRow>
										</TableHead>

										<TableBody>
											{getFeeReportListArray &&
												[]
													.concat(getFeeReportListArray)
													.slice(
														page * rowsPerPage,
														page * rowsPerPage + rowsPerPage
													)
													.map((row, index) => (
														<TableRow key={index}>
															<TableCell align="center">
																{row.userRole}
															</TableCell>

															<TableCell align="center">
																{row.transactionType}
															</TableCell>
															<TableCell align="center">
																{row.transactionSubType}
															</TableCell>
															<TableCell align="center">
																{row.currency}
															</TableCell>
															<TableCell align="center">
																{row.noOfTransaction}
															</TableCell>
															<TableCell align="center">
																{row.creditAmount}
															</TableCell>
															<TableCell align="center">
																{row.debitAmount}
															</TableCell>
														</TableRow>
													))}
										</TableBody>
									</Table>
									<TablePagination
										rowsPerPageOptions={[5, 10, 25]}
										component="div"
										count={[].concat(getFeeReportListArray).length}
										rowsPerPage={rowsPerPage}
										page={page}
										onChangePage={handleChangePage}
										onChangeRowsPerPage={handleChangeRowsPerPage}
									/>
								</TableContainer>
							</Grid>
						</Card>
					</div>
				)}
			</Layout>
		</>
	);
};

export default DealerFeeReport;
